module.exports = __webpack_public_path__ + "img/yy.b381a28f.png";